import React, { useState, useEffect } from "react";
import '../styles/other.css';
import '../styles/pages.css';
import Axios from 'axios';
import CsvDownloadButton from 'react-json-to-csv';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';
import { fetchContactImage } from '../utilities/OtherUtilities.js';

// import components
import AddFinRoleTile from '../tiles/AddFinRoleTile.js';
import FinWorkflowTile from '../tiles/FinWorkflowTile.js';

class ListFinWorkflow extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            /*workflowData: ([]),*/
            workflowData: ([{id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"},
                                {id: 2, user: "John Smith", role: "CTL approvement", country: "Albania", created_by: "John Supersmith"}]),
            totalNumberOfContacts: 0,
            noRecordsFound: false,
            editRole: 0,
        }

    }

    componentDidMount(){
        //this.loadData();
        this.setActualSection("fin_workflow");
    }

    componentDidUpdate(prevProps, prevState) {
    }

    loadData = () => {
        this.setState({ noRecordsFound: false });
        this.setState({ workflowData: [] });
        this.setState({ totalNumberOfContacts: 0 });

        //var getOnlyMyContacts = this.props.searchText == "" ? 1 : 0; // If I am searching it would search in all, if not it gives me my contacts
        // now it works according to the MY/ALL switch, not if there is some searchText or not
        var getOnlyMyContacts = this.props.allOrMy == "my" ? 1 : 0;
        var url = '/api/cont/get?tp=1&my='+getOnlyMyContacts;
        Axios.get(url).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ workflowData: response.data.result });
            this.setState({ totalNumberOfContacts: response.data.msg.cnt });
            if(response.data.result.length == 0){ this.setState({ noRecordsFound: true }); }


            // save the ids array to memory
            var idsArray = response.data.result.map(a => a.id);
            localStorage.setItem('idsArray', JSON.stringify(idsArray));
        });
    }

    setEditRole = (id) => {
        this.setState({ editRole: id });
    }

    render() {
        return (
            <div className="verticalStack flex" style={{height: "calc(100vh - 80px)", overflowY: "scroll"}}>
                <div className="horizontalStackCenter universalTableListingBar">
                    <span className="fontPoppinsRegular13Gray">{" Financial Workflow Settings"}</span>
                    <div className="flex"/>
                </div>

                <div className="horizontalStack flex">
                    <div className="verticalStack flex" style={{position: "relative"}}>
                        <FinWorkflowTile workflowData={this.state.workflowData} setEditRole={this.setEditRole} openAlertMessageTwoActions={this.props.openAlertMessageTwoActions} />
                    </div>

                    <div className="verticalStack">
                        <AddFinRoleTile editRole={this.state.editRole} setEditRole={this.setEditRole} openAlertMessageTwoActions={this.props.openAlertMessageTwoActions} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ListFinWorkflow;
